import Vue from 'vue'
import Router from 'vue-router'
import download from '@/components/download'
import goods from '@/components/goods'
import newGoods from '@/components/newGoods'
import shopInfo from '@/components/shopInfo'
import download1 from '@/components/download1'
import activityCollage from '@/components/activityCollage'
import bargain from '@/components/bargain'
import mallGoodsDetails from '@/components/mallGoodsDetails'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/download1',
      name: 'download1',
      component: download1
    },
    {
      path: '/newGoods',
      name: 'goods',
      component: goods
    },
    {
      path: '/',
      name: 'newGoods',
      component: newGoods
    },
    {
      path: '/shopInfo',
      name: 'shopInfo',
      component: shopInfo
    },
    {
      path: '/activity-collage',
      name: 'activityCollage',
      component: activityCollage
    },
    {
      path: '/activity-bargain',
      name: 'activity-bargain',
      component: bargain
    },
    {
      path: '/mallGoodsDetails',
      name: 'mallGoodsDetails',
      component: mallGoodsDetails
    },
    {
      path: '/business',
      name: 'business',
      component: resolve => require(['@/pages/business/index'], resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/business/search',
      name: 'businessSearch',
      component: resolve => require(['@/pages/business/search'], resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/business/classifyList',
      name: 'businessClassifyList',
      component: resolve => require(['@/pages/business/classifyList'], resolve),
      meta: {keepAlive: true}
    },
    {
      path: '/business/articleDetail',
      name: 'businessArticleDetail',
      component: resolve => require(['@/pages/business/articleDetail'], resolve)
    },
    {
      path: '/business/noAccess',
      name: 'noAccess',
      component: resolve => require(['@/pages/business/noAccess'], resolve)
    },
    // 分享中间页
    {
      path: '/middlePage',
      name: 'shareMiddlePages',
      component: resolve => require(['@/pages/share_middle_pages/'], resolve)
    },
    // 活动分享页
    {
      path: '/activity',
      name: 'activity',
      component: resolve => require(['@/pages/share_middle_pages/activity'], resolve)
    },
    // 绑定手机号
    {
      path: '/bindPhone',
      name: 'bindPhone',
      component: resolve => require(['@/pages/bind_phone/'], resolve)
    },
    // 特权卡申请
    {
      path: '/applyForCard',
      name: 'applyForCard',
      component: resolve => require(['@/pages/privilege_card/applyForCard'], resolve),
      meta:{title:'特权卡申请'}
    },
    {
      path: '/cardPayment',
      name: 'cardPayment',
      component: resolve => require(['@/pages/privilege_card/cardPayment'], resolve),
      meta:{title:'确认支付'}
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: resolve => require(['@/pages/privilege_card/paySuccess'], resolve),
      meta:{title:'支付成功'}
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js